import type { EventEnvelope } from "./envelope.js";
import type { Reporter } from "./telemetry-client.js";

export interface HttpReporterOptions {
  /** 完整上报地址，如 `http://127.0.0.1:8000/api/v1/physics/events`（tech/108 §8.3）。 */
  endpoint: string;
  token?: string;
  fetchImpl?: typeof fetch;
}

/** 把信封原样 POST 给后端；网络/非 2xx 一律返回 `ok:false`，交给 TelemetryClient 的离线队列重试。 */
export class HttpReporter implements Reporter {
  constructor(private readonly options: HttpReporterOptions) {}

  async send(envelope: EventEnvelope): Promise<{ ok: boolean }> {
    const fetchImpl = this.options.fetchImpl ?? fetch;
    const headers: Record<string, string> = { "Content-Type": "application/json" };
    if (this.options.token) {
      headers.Authorization = `Bearer ${this.options.token}`;
    }
    try {
      const response = await fetchImpl(this.options.endpoint, {
        method: "POST",
        headers,
        body: JSON.stringify(envelope),
      });
      return { ok: response.ok };
    } catch {
      return { ok: false };
    }
  }
}
